(() => {
  'use strict';
  const configEl = document.getElementById('ThemeConfig');
  const config = configEl ? JSON.parse(configEl.textContent) : {root: '/'};
  const route = path => `${config.root || '/'}${path}`;
  const initialized = new WeakSet();
  let noticeTimer;
  function notice(message) {
    const box = document.getElementById('CartNotice');
    if (!box) return;
    box.querySelector('[data-cart-message]').textContent = message;
    box.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => { box.hidden = true; }, 9000);
  }
  async function updateCartCount() {
    try {
      const response = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
    } catch { /* A successful add is still successful if the count refresh fails. */ }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-pincode-form]')) {
      event.preventDefault();
      const pin = form.elements.pincode.value.trim();
      const result = form.querySelector('[data-pincode-result]');
      if (!/^[1-9]\d{5}$/.test(pin)) { result.textContent = 'Please enter a valid 6-digit India PIN code.'; return; }
      const allowed = (config.pincodes || '').split(/[\s,;]+/).filter(value => /^[1-9]\d{5}$/.test(value));
      result.textContent = allowed.length ? (allowed.includes(pin) ? `Delivery available for ${pin}. ${config.deliveryEstimate || ''} Final charges and delivery options are confirmed at checkout.` : `Delivery is not listed for ${pin}. Please contact us to confirm availability.`) : (config.deliveryConfirm || 'Delivery availability, shipping charges and dates are confirmed at checkout.');
      return;
    }
    if (!form.matches('[data-quick-add], [data-product-form]')) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = event.submitter || form.querySelector('[type=submit]');
    const buyNow = !!button?.matches('[data-buy-now]');
    const error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    const data = new FormData(form);
    data.delete('return_to');
    const buttons = [...form.querySelectorAll('button[type=submit]')];
    const states = buttons.map(b => ({button:b,disabled:b.disabled,text:b.textContent}));
    form.dataset.submitting = 'true';
    buttons.forEach(b => { b.disabled = true; });
    if (button) button.textContent = buyNow ? 'Preparing checkout…' : 'Adding…';
    let added = false;
    try {
      const response = await fetch(route('cart/add.js'), {method:'POST',headers:{Accept:'application/json'},body:data});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'This product could not be added. Please check your selection.');
      added = true;
      if (buyNow) { window.location.assign(route('checkout')); return; }
      notice('Added to your cart.');
      await updateCartCount();
    } catch (issue) {
      // Do not retry a potentially completed add after a network interruption.
      const message = issue instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : issue.message;
      if (error) { error.textContent = message; error.hidden = false; }
    } finally {
      form.dataset.submitting = 'false';
      if (!buyNow || !added) states.forEach(state => { state.button.disabled = state.disabled; state.button.textContent = state.text; });
    }
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-dismiss-notice]');
    if (close) { document.getElementById('CartNotice').hidden = true; clearTimeout(noticeTimer); }
    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      const input = quantityButton.closest('.quantity-control').querySelector('input');
      const min = Number(input.min || 0), step = Number(input.step || 1), max = input.max === '' ? Infinity : Number(input.max);
      let value = Number(input.value || input.min || 1);
      const up = quantityButton.hasAttribute('data-quantity-plus');
      const cartMin = Number(input.dataset.cartMin || 0);
      value = up ? value + step : value - step;
      if (cartMin && value > 0 && value < cartMin) value = up ? cartMin : 0;
      input.value = Math.max(min, Math.min(max, value));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) showMedia(mediaButton.closest('[data-product-section]'), mediaButton.dataset.mediaTarget);
  });
  function showMedia(section, id) {
    if (!section || !id || !section.querySelector(`[data-media-id="${id}"]`)) return;
    section.querySelectorAll('[data-media-id]').forEach(media => {
      media.hidden = media.dataset.mediaId !== id;
      if (media.hidden) {
        media.querySelectorAll('video').forEach(video => video.pause());
        media.querySelectorAll('iframe').forEach(frame => {
          const src = frame.getAttribute('src');
          if (src) frame.setAttribute('src', src);
        });
      }
    });
    section.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
  }
  document.addEventListener('change', event => {
    const select = event.target;
    if (!select.matches('[data-variant-select]')) return;
    const section = select.closest('[data-product-section]');
    const option = select.selectedOptions[0];
    if (!option) return;
    section.querySelectorAll('[data-price]').forEach(el => { el.textContent = option.dataset.price; });
    section.querySelectorAll('[data-compare-price]').forEach(el => { el.textContent = option.dataset.comparePrice || ''; el.hidden = !option.dataset.comparePrice; });
    section.querySelectorAll('[data-unit-price]').forEach(el => { el.textContent = option.dataset.unit || ''; el.hidden = !option.dataset.unit; });
    const available = option.dataset.available === 'true';
    section.querySelectorAll('[data-add-button], [data-buy-now]').forEach(button => { button.disabled = !available; if (button.matches('[data-add-button]')) button.textContent = available ? 'Add to cart' : 'Sold out'; });
    const qty = section.querySelector('[name="quantity"]');
    if (qty) {
      qty.min = option.dataset.min || '1'; qty.step = option.dataset.step || '1';
      if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
      qty.value = qty.min;
    }
    showMedia(section, option.dataset.media);
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
  });
  function initSlider(slider) {
    if (initialized.has(slider)) return;
    initialized.add(slider);
    const slides = [...slider.querySelectorAll('[data-slide]')];
    if (!slides.length) return;
    let index = 0, timer = null, paused = false, hovering = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const setSlide = n => {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide,i) => { slide.hidden = i !== index; slide.classList.remove('slide-secondary'); });
      slider.querySelectorAll('[data-slide-go]').forEach((dot,i) => dot.setAttribute('aria-current', String(i === index)));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!paused && !hovering && !reduced && !document.hidden && !slider.contains(document.activeElement) && slider.dataset.autoplay === 'true' && slides.length > 1) timer = setInterval(() => setSlide(index + 1), Number(slider.dataset.interval) || 6000);
    };
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => { setSlide(index - 1); start(); });
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => { setSlide(index + 1); start(); });
    slider.querySelectorAll('[data-slide-go]').forEach(button => button.addEventListener('click', () => { setSlide(Number(button.dataset.slideGo)); start(); }));
    slider.querySelector('[data-slide-pause]')?.addEventListener('click', event => { paused = !paused; event.currentTarget.textContent = paused ? 'Play' : 'Pause'; event.currentTarget.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); start(); });
    slider.addEventListener('mouseenter', () => { hovering = true; stop(); });
    slider.addEventListener('mouseleave', () => { hovering = false; start(); });
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', () => setTimeout(start, 0));
    const onVisibility = () => document.hidden ? stop() : start();
    document.addEventListener('visibilitychange', onVisibility);
    const onUnload = event => { if (event.target.contains(slider)) { stop(); document.removeEventListener('visibilitychange',onVisibility); document.removeEventListener('shopify:section:unload',onUnload); } };
    document.addEventListener('shopify:section:unload',onUnload);
    slider.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-slide]'); if (slide) { paused = true; stop(); setSlide(slides.indexOf(slide)); } });
    setSlide(0); start();
  }
  function initRecommendations(container) {
    if (initialized.has(container)) return;
    initialized.add(container);
    const load = async () => {
      try {
        const response = await fetch(container.dataset.url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const result = doc.querySelector('[data-recommendations]');
        if (result && result.querySelector('.product-card')) container.innerHTML = result.innerHTML;
      } catch { /* Keep the server-rendered collection fallback. */ }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, {rootMargin:'300px'});
      observer.observe(container);
    } else load();
  }
  function init(scope = document) {
    // Keep a canonical variant input inside the form for Shopify payment/app scripts.
    // Without JavaScript, the select's native form association still posts the variant.
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const select = section.querySelector('[data-variant-select]');
      const form = section.querySelector('[data-product-form]');
      if (!select || !form || form.querySelector('[data-variant-id]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'id'; input.value = select.value; input.dataset.variantId = '';
      form.appendChild(input); select.removeAttribute('name');
      select.addEventListener('change', () => { input.value = select.value; input.dispatchEvent(new Event('change', {bubbles:true})); });
    });
    scope.querySelectorAll('[data-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('.review-form-wrap').forEach(details => { if (details.querySelector('.success-message,.errors') || location.hash === `#${details.id}` || location.hash.includes('ProductReviewContact')) details.open = true; });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#ReviewForm-"]');
    if (link) { const details = document.querySelector(link.getAttribute('href')); if (details) details.open = true; }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open],.filter[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
